import { render, staticRenderFns } from "./UnifiedMessageRenderer.vue?vue&type=template&id=7e7bbba2&scoped=true"
import script from "./UnifiedMessageRenderer.vue?vue&type=script&lang=js"
export * from "./UnifiedMessageRenderer.vue?vue&type=script&lang=js"
import style0 from "./UnifiedMessageRenderer.vue?vue&type=style&index=0&id=7e7bbba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7bbba2",
  null
  
)

export default component.exports